{
  "generate_callsheet": "Generate Callsheet",
  "header": "Header",
  "location": "Location",
  "schedule": "Schedule",
  "talent_cast": "Talent - cast",
  "talent_crew": "Talent - crew",
  "notes": "Notes",
  "weather": "Weather",
  "date": "Date",
  "shooting_day": "Shooting day",
  "call_times": "Call times",
  "general": "General",
  "crew_call": "Crew call",
  "lunch": "Lunch",
  "cast_call": "Cast call",
  "extras_call": "Extras call",
  "vip_contact": "VIP contact",
  "name": "Name",
  "role": "Role",
  "phone": "Phone",
  "email": "E-mail",
  "add_location": "Add location",
  "start": "Start",
  "scene": "Scene",
  "scene_description": "Scene description",
  "estimated_time": "Estimated time",
  "add_schedule": "Add schedule",
  "talent": "Talent",
  "pick_up": "Pick up",
  "call": "Call",
  "on_set": "On set",
  "add_cast": "Add cast",
  "note": "Note",
  "field_required": "This field is required",
  "location_name": "Location name",
  "address": "Address",
  "city": "City",
  "sunrise": "sunrise",
  "sunset": "sunset",
  "locations": "locations",
  "calls": "calls",
  "general_call": "general call",
  "crew": "crew",
  "cast": "cast"
}
